module.exports = __webpack_public_path__ + "img/icons/new/person-with-plus-pg-682dda70db612c8a6961ef8194f9c651.svg";